import { pick, uniq, values } from 'lodash-es'
import { getWikimediaLanguageCodeFromWdUri, getWikimediaLanguageCodesFromWdUris } from '#app/lib/languages/languages_indexes'
import { pickOne, objLength } from '#app/lib/utils'
import type { PropertyUri, WdEntityUri } from '#server/types/entity'
import type { PreSerializedEntity, SerializedEntity } from './entities'

const langProperties = [
  'wdt:P103', // native language
  'wdt:P407', // language of work
  'wdt:P1412', // languages spoken, written or signed
  'wdt:P2439', // language (general)
] as const

export async function getOriginalLang (claims: SerializedEntity['claims']) {
  const langClaims = pick(claims, langProperties)
  if (objLength(langClaims) === 0) return

  const originalLangUri = pickOne(langClaims)?.[0]
  if (originalLangUri != null) {
    return getWikimediaLanguageCodeFromWdUri(originalLangUri)
  }
}

export async function fetchEntitiesLanguageCodes (entities: PreSerializedEntity[]) {
  let langUris = entities
    .map(entity => {
      const languageClaims = pick(entity.claims, langProperties) as Record<PropertyUri, WdEntityUri[]>
      return values(languageClaims).flat()
    }).flat()
  langUris = uniq(langUris)
  return getWikimediaLanguageCodesFromWdUris(langUris)
}
